import OBase from './OBase';

import * as Geometry from '../geometry';

export default class ArcCosine extends OBase {
  update () {
    let valTree = this.getFloatInput('Value');
    let pOutput = this.getGenericObjectOutput('Result');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        let nval = Math.acos(val);
        outTree.add(nval, valTree.paths[i]);
      }
    }

    pOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ArcCosine.js